import { render, staticRenderFns } from "./StudentTop.vue?vue&type=template&id=52c6b2f0&scoped=true&"
import script from "./StudentTop.vue?vue&type=script&lang=js&"
export * from "./StudentTop.vue?vue&type=script&lang=js&"
import style0 from "./StudentTop.vue?vue&type=style&index=0&id=52c6b2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c6b2f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
